import { render, staticRenderFns } from "./AutoExtensionPanel.vue?vue&type=template&id=1950c6b0&scoped=true&"
import script from "./AutoExtensionPanel.vue?vue&type=script&lang=js&"
export * from "./AutoExtensionPanel.vue?vue&type=script&lang=js&"
import style0 from "./AutoExtensionPanel.vue?vue&type=style&index=0&id=1950c6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950c6b0",
  null
  
)

export default component.exports